/* eslint-disable prettier/prettier */
/* eslint-disable office-addins/no-context-sync-in-loop */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-undef */
//import { ContextExclusionPlugin } from "webpack";

import { formatSelectedTableBuildIn, formatIntermediateSumRow, formatSelectedTable, sumArrays, styleTable } from "./utils/utils.js";
import { generateTable, readFile } from "./utils/data.js";

const configurl = 'https://raw.githubusercontent.com/Randers-Kommune-Digitalisering/budget-word-app-config/refs/heads/main/';

const required_styles = ["Brev/notat KORT (O1)"];
const allowed_files = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
let dialog = null;

const loginUrl = process.env.CONFIG_LIBRARY_URL;
const credentials = {
  username: process.env.CONFIG_LIBRARY_USER,
  password: process.env.CONFIG_LIBRARY_PASS,
};


Office.onReady((info) => {
  if (info.host === Office.HostType.Word) {
    document.getElementById("skabelon").onclick = () => tryCatch(() => hasStyles(() => tryCatch(skabelon)));
    document.getElementById("loadContentControls").onclick = () => tryCatch(loadElements);
    document.getElementById("loadSelection").onclick = () => tryCatch(loadSelection);
    document.getElementById("rydAlt").onclick = () => tryCatch(rydAlt);
    document.getElementById("rydSidehoved").onclick = () => tryCatch(rydSidehoved);
    document.getElementById("rydAltTools").onclick = () => tryCatch(rydAlt);
    document.getElementById("rydAltDev").onclick = () => tryCatch(rydAlt);
    document.getElementById("rydValgtTabel").onclick = () => tryCatch(rydValgtTabel);
    document.getElementById("formaterTabellerBO").onclick = () => tryCatch(formatAllTables);
    document.getElementById("formatSelectedTable").onclick = () => tryCatch(formatSelectedTable);
    document.getElementById("formatSelectedTableBuiltIn").onclick = () => tryCatch(formatSelectedTableBuildIn);
    document.getElementById("formatIntermediateSumRow").onclick = () => tryCatch(formatIntermediateSumRow);
    document.getElementById("loadBookmark").onclick = () => tryCatch(loadBookmark);
    document.getElementById("sideload-msg").style.display = "none";
    document.getElementById("app-body").style.display = "flex";
    document.getElementById("file").addEventListener("change", checkfile);

    console.log(process.env.CONFIG_LIBRARY_URL); 
    // fetchConfigFile("ØU")
  }
});

export async function formatAllTables() {
  return Word.run(async (context) => {
    // Load all tables in the document
    const tables = context.document.body.tables;
    tables.load("items");
    await context.sync();

    // Loop through each table and format it
    for (let i = 0; i < tables.items.length; i++) {
      const table = tables.items[i];
      table.select(); // Select the table
      // context.trackedObjects.add(table);

      // Call the formatSelectedTable function
      await formatSelectedTable();

      // context.trackedObjects.remove(table);
    }

    console.log("All tables have been formatted.");
  });
}

export async function rydValgtTabel() {
  return Word.run(async (context) => {
    // Loader valgt tabel
    const selection = context.document.getSelection();
    selection.load("parentTable");
    await context.sync();
    const table = selection.parentTable;  

    var bookmark = table.getRange().getBookmarks(true);
    await context.sync();
    if (bookmark.m_value && bookmark.m_value.length > 0) {
      console.log(bookmark.m_value[0]);
    } else {
      console.log("Intet bogmærke fundet");
    }

    // Fjerner tabel
    table.delete();
    await context.sync();


  });
}

function fetchConfigFile(file) {
  fetch(loginUrl+"/api/file/budget-word-app/"+file+".json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  })
    .then(response => response.json())
    .then(data => {
      const token = data.token; // Assuming the token is in the response
      console.log("Token:", token);
  
      // Use the token for subsequent requests
      return fetch(loginUrl+"/api/file/budget-word-app/"+file+".json", {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
    })
    .catch(error => {
      console.error("Error:", error);
    });
  } 
 
function openDialog(title, message) {
  var title = title ? title : "Fejl";
  var message = message ? message : "Der er sket en fejl. Prøv igen.";
  Office.context.ui.displayDialogAsync(
    "https://localhost:3000/popup.html?messageTitle=" + String(title) + "&message=" + String(message),
    { height: 25, width: 7 },

    function (result) {
      dialog = result.value;
      dialog.addEventHandler(Microsoft.Office.WebExtension.EventType.DialogMessageReceived, processMessage);
    }
  );
}

function processMessage(arg) {
  console.log(arg.message);
  dialog.close();
}

function buildTableMatrix(rows, columns, projects = null, total = true, rowsFullArray = null, datasheet=0) {
  var projects = [projects];
  var data = [columns];
  var inputRows = rowsFullArray == null ? rows : rowsFullArray; 
  console.log("withData", withData);
  var dataFromFile = generateTable(columns, inputRows, withData, valgtDokumentDetajle, fileType, datasheet);

  if (projects[0] != null) {
    var dataFromFile = dataProjectsTotalsRounding(dataFromFile, projects, "I alt ekskl. projekter", withData, valgtDokumentDetajle, fileType, total);
  } else {
    var dataFromFile = dataProjectsTotalsRounding(dataFromFile, null, null, withData, valgtDokumentDetajle, fileType, total);
  }
  
  data = dataFromFile;
  return data
}

async function tryCatch(callback) {
  try {
    await callback();
  } catch (error) {
    openDialog("Fejl", error.toString());
    /*console.error(error.message);*/
  }
}

export async function loadBookmark() {
  return Word.run(async (context) => {
    var bookmark = context.document.getSelection().getRange().getBookmarks(true);
    await context.sync();
    if (bookmark.m_value && bookmark.m_value.length > 0) {
      console.log(bookmark.m_value[0]);
      return bookmark.m_value[0].name;
    } else {
      console.log("Intet bogmærke fundet");
      return null;
    } 
  });
}

function insertBookmark(table, name, prefix) {
  var range = table.getRange();
  if (prefix == "") {
    var bookmark = "_"+name;
  } else {
    var bookmark = "_"+prefix+"_"+name;
  }
  console.log(bookmark);
  range.insertBookmark(bookmark);
}


export async function loadSelection() {
  return Word.run(async (context) => {
    var selection = context.document.getSelection();
    await context.sync();
    selection.load("ParentTable, ParentTableCell");

    console.log(selection);
  })
}


export async function loadElements() {
  return Word.run(async (context) => {
    var contentControls = context.document.contentControls;
    contentControls.load("items");
    await context.sync();
    console.log("Content controls");
    for (var key in contentControls.items) {
      if (contentControls.items.hasOwnProperty(key)) {
        console.log(contentControls.items[key]._Ti, ": ", contentControls.items[key]._Te);
      }
    }

    var afsnit = context.document.body.paragraphs;
    afsnit.load("items");
    await context.sync();
    console.log("Afsnit");
    for (var key in afsnit.items) {
      if (afsnit.items.hasOwnProperty(key)) {
        console.log(afsnit.items[key]._Te);
      }
    }

    var tables = context.document.body.tables;
    tables.load("items");
    await context.sync();
    console.log("Tabeller");
    console.log(tables);
    for (var key in tables.items) {
      if (tables.items.hasOwnProperty(key)) {
        console.table(tables.items[key]._V);
      }
    }
  });
}

export async function indlæsAfsnit(placering) {
  return Word.run(async (context) => {
    var afsnit = context.document.body.paragraphs.load(["text", "style"]);
    await context.sync();
    var items = afsnit.items;
    var overskrift = [];
    var overskriftNiveau = [];
    for (var i in items) {
      if (items[i].style.slice(0, 10) == "Overskrift") {
        var nyOverskrift = items[i].text;
        var nyOverskriftNiveau = items[i].style.slice(-1);
        if (nyOverskriftNiveau == overskriftNiveau.slice(-1)) {
          overskrift.pop();
          overskriftNiveau.pop();
          overskrift.push(nyOverskrift);
          overskriftNiveau.push(nyOverskriftNiveau);
        }
        if (nyOverskriftNiveau > overskriftNiveau.slice(-1)) {
          overskrift.push(nyOverskrift);
          overskriftNiveau.push(nyOverskriftNiveau);
        }
        if (nyOverskriftNiveau < overskriftNiveau.slice(-1)) {
          while (nyOverskriftNiveau < overskriftNiveau.slice(-1)) {
            overskrift.pop();
            overskriftNiveau.pop();
          }
          overskrift.pop();
          overskriftNiveau.pop();
          overskrift.push(nyOverskrift);
          overskriftNiveau.push(nyOverskriftNiveau);
        }

        if (placering == overskrift.slice(1, overskrift.length).toString().replaceAll(",", " ")) {
          return i;
        }
      }
    }
  });
}

export async function rydSidehoved() {
  return Word.run(async (context) => {
    // Ryd tekst i header
    var header = context.document.sections.getFirst().getHeader("primary");

    var afsnit = header.paragraphs; 
    context.load(afsnit, "text");
    await context.sync();
    for (var i = 0; i < afsnit.items.length; i++) {
      afsnit.items[i].delete();
    }

    // Ryd tekst i header
    var footer = context.document.sections.getFirst().getFooter("primary");

    var afsnit = footer.paragraphs;
    context.load(afsnit, "text");
    await context.sync();
    for (var i = 0; i < afsnit.items.length; i++) {
      afsnit.items[i].delete();
    } 
  });
}

export async function rydAlt() {
  return Word.run(async (context) => {
    // Ryd alt i body
    context.document.body.clear();
    await context.sync();
    withData = false;
  });
}

export async function indsætContentControl(name) {
  return Word.run(async (context) => {
    context.document.body.paragraphs.getLast().select("End");
    var selection = context.document.getSelection();
    const cc = selection.insertContentControl("RichText");
    cc.title = name;

    genContentControls.push(name);
    await context.sync();
  });
}

export async function indsætSektion(tekst) {
  return Word.run(async (context) => {
    context.document.body.paragraphs.getLast().select("End");
    var selection = context.document.getSelection();

    const overskrift = selection.insertParagraph(tekst);
    overskrift.styleBuiltIn = "Heading2";

    await context.sync();
    await indsætContentControl(tekst);

    selection.insertParagraph("", "After");
  });
}

export async function indsætUndersektioner(
  sektion,
  undersektioner,
  ekstraTekst,
  heading,
  budgetperiodeÅr1,
  budgetperiodeÅr4
) {
  return Word.run(async (context) => {
    context.document.body.paragraphs.getLast().select("End");
    var selection = context.document.getSelection();
    for (var key in undersektioner) {
      const tekstUndersektion = undersektioner[key];

      const parse = require("json-templates");
      const templateUndersektion = parse(tekstUndersektion);

      var underoverskrift = selection.insertParagraph(
        templateUndersektion({ fra: budgetperiodeÅr1, til: budgetperiodeÅr4 })
      );
      underoverskrift.styleBuiltIn = heading;
      context.document.body.paragraphs.getLast().select("End");
      await context.sync();
      await indsætContentControl(sektion + " " + ekstraTekst + " " + tekstUndersektion);
      selection.insertParagraph("", "After");
    }
    await context.sync();
  });
}

// Funktion til at indsætte sektioner i contentcontrols
export async function indsætSektionerICC(cc, undersektioner, heading, numbered = false, prefix = "") {
  return Word.run(async (context) => {
    const contentControls = context.document.contentControls;
    contentControls.load("id");

    await context.sync();

    const targetCC = genContentControls.indexOf(cc);
    const last = contentControls.items[targetCC];
    //var temp=last.insertParagraph('',"End")
    // .styleBuiltIn="Normal";
    for (var undersektion in undersektioner) {
      if (undersektioner.length > 1) {
        if (numbered) {
          var undersektionnr = parseInt(undersektion) + 1;
          var underoverskrift = prefix
            .concat(".")
            .concat(undersektionnr)
            .concat(" ")
            .concat(undersektioner[undersektion]);
        } else {
          var underoverskrift = undersektioner[undersektion];
        }
        var indsat = last.insertParagraph(underoverskrift, "End");
        indsat.styleBuiltIn = "Normal";
        indsat.styleBuiltIn = heading;
      }
      last.insertParagraph("", "End").styleBuiltIn = "Normal";
    }
    await context.sync();
  });
}

// Funktion til at gemme et JSON-objekt i dokumentkommentarerne til viderebehandling i VBA.
export async function tableAltBeskObj(titel, beskrivelse, tabelnr = 0) {
  return Word.run(async (context) => {
    var temp = context.document.properties.load("comments");
    await context.sync();
    if (temp.comments != "") {
      var tempjson = JSON.parse(temp.comments);
      var i = tempjson[Object.keys(tempjson)[Object.keys(tempjson).length - 1]].nr;
      i++;
    } else {
      var i = 1;
    }

    if (tabelnr == 0) {
      dokumentKommentarer.push({ nr: i, titel: titel, beskrivelse: beskrivelse });
    } else {
      dokumentKommentarer.splice(tabelnr - 1, 0, { nr: i, titel: titel, beskrivelse: beskrivelse });
    }

    // Renummerer tabeller (custom tabeller kan sættes ind over alt)
    for (var j = 0; j < dokumentKommentarer.length; j++) {
      dokumentKommentarer[j].nr = j + 1;
    }

    context.document.properties.set({ comments: JSON.stringify(dokumentKommentarer) });
    await context.sync();
  });
}
function roundNestedArray(arr) {
  return arr.map((innerArr) =>
    innerArr.map((item) =>
      //typeof item === 'number' ? Math.round(item * 10) / 10 : item
      typeof item === "number" ? item.toFixed(1).replace(".", ",") : item
    )
  );
}

function dataProjectsTotalsRounding(
  data,
  projekter = null,
  deletekst = "I alt uden projekter",
  withData,
  valgtDokumentDetajle,
  fileType,
  indsætTotalRække = true
) {
  let dataOutput = [...data];

  if (projekter != null) {
    // Total uden projekter
    let dataTotalProjekter = sumArrays(
      ...data.map((arr) => arr.slice(1)).map((subarray) => subarray.map((el) => parseFloat(el)))
    );
    let totalRækkeProjekter = [deletekst];
    totalRækkeProjekter = totalRækkeProjekter.concat(dataTotalProjekter);
    dataOutput.push(totalRækkeProjekter);
    // Projekter
    let projektData = generateTable(data[0], projekter, withData, valgtDokumentDetajle, fileType);
    data.push(projektData[1]);
    dataOutput.push(projektData[1]);
  }

  // Total
  let dataTotal = undefined;
  if (withData)
    dataTotal = sumArrays(...data.map((arr) => arr.slice(1)).map((subarray) => subarray.map((el) => parseFloat(el))));
  else dataTotal = new Array(data[0].length - 1);
  if (indsætTotalRække) {
    let totalRække = ["I alt"];
    totalRække = totalRække.concat(dataTotal);
    dataOutput.push(totalRække);
  }
  dataOutput = roundNestedArray(dataOutput);

  return dataOutput;
}

export async function tabelAddOns(tabel, placering, projekter = 0, fodnote = 0, data = null) {
  return Word.run(async (context) => {
    if (fodnote != 0) {
      var indsatFodnote = placering.insertText(fodnote, "End");
      indsatFodnote.font.size = 8;
      indsatFodnote.font.italic = true;
    }
  });
}

export async function fetchAssets(adr) {
  return Word.run(async (context) => {
    var response = await fetch(adr, { cache: "reload" });
    return response.json();
  });
}

// New helper functions

function checkfile(e) {
  var fileTypeDropdown = document.getElementById("fileTypeDropdown");

  if (fileTypeDropdown.options.length < 1) {
    let option_normal = document.createElement("option");
    option_normal.text = "normal";
    option_normal.value = "default";
    fileTypeDropdown.add(option_normal);

    let option_expanded = document.createElement("option");
    option_expanded.text = "ekspanderet";
    option_expanded.value = "expanded";
    fileTypeDropdown.add(option_expanded);
  }

  fileTypeDropdown.options.selectedIndex = 0;

  if (e.target.files[0]) {
    const file = e.target.files[0];
    if (allowed_files.includes(file.type)) {
      readFile(file);
      withData = true;
    } else {
      withData = false;
      fileTypeDropdown.classList.add("skjult");
      openDialog("Fejl", "Filen er ikke af den korrekte type. Det skal være en Excel-fil.");
    }
  } else {
    withData = false;
    fileTypeDropdown.classList.add("skjult");
  }
}

function hasStyles(callback) {
  Office.context.document.getSelectedDataAsync(Office.CoercionType.Ooxml, (result) => {
    var style_present = true;
    required_styles.forEach((style) => {
      style_present = result.value.includes(style) && style_present;
    });
    if (style_present) {
      callback();
    } else {
      openDialog("Fejl - Dokumentet har ikke de nødvendige stilarter", "Åben Startskabelonen");
    }
  });
}

// Global variables
var fileType, valgtDokumentDetajle;
let withData = false;

// Generer skabelonen
export async function skabelon() {  
  return Word.run(async (context) => {
    globalThis.genContentControls = [];
    globalThis.dokumentKommentarer = [];

    const valgtDokument = document.getElementById("dokumentDropdown").value;
    valgtDokumentDetajle = document.getElementById("dokumentDetaljeDropdown").value;
    const valgtUdvalg = document.getElementById("udvalgDropdown").value;
    const valgtBevilling = document.getElementById("bevillingsområdeDropdown").value;

    fileType = document.getElementById("fileTypeDropdown").value;

    const responseDokumenttype = await fetch(configurl+"dokumenttype.json", { cache: "reload" });
    const dokumenttypeJSON = await responseDokumenttype.json();

    const dokumentdata = dokumenttypeJSON.filter((obj) => obj.type == valgtDokument);
    const sektioner = dokumentdata[0].sektioner;
    const undersektioner = dokumentdata[0].undersektioner;
    const tabelindhold = dokumentdata[0].tabelindhold;
    const notatDetaljer = dokumentdata[0].notatdetaljer;
    const langtNavn = dokumentdata[0].langtNavn;

    var organisationJSON = await fetchAssets(configurl+"organisation.json");
    var organisationdata = organisationJSON.filter((obj) => obj.udvalg == valgtUdvalg);

    /* Udlæser bevillingsområder fra første dokumenttype - ændrer sig ikke på tværs af typer*/
    const bevillingsområder = [];
    for (var i in organisationdata[0].dokumenter[0].bevillingsområde) {
      bevillingsområder.push(organisationdata[0].dokumenter[0].bevillingsområde[i].navn);
    }

    // Indlæser sektionsafgrænsninger
    var afgrænsningsdata = organisationdata[0].dokumenter.filter((obj) => (obj.navn = valgtDokument));

    const inkluderSektioner = [];
    for (var i in afgrænsningsdata[0].sektioner) {
      inkluderSektioner.push(afgrænsningsdata[0].sektioner[i]);
    }

    const inkluderUndersektioner = [];
    for (var i in afgrænsningsdata[0].undersektioner) { 
      inkluderUndersektioner.push([afgrænsningsdata[0].undersektioner[i]]);
    }
    const inkluderUndersektionerFlat = inkluderUndersektioner.flat(Infinity);
    const currentYear = new Date(Date.now()).getFullYear();
    const lastYear = currentYear - 1;
    const lastYear2 = currentYear - 2;
    const budgetperiodeÅr1 = currentYear + 1;
    const budgetperiodeÅr2 = currentYear + 2;
    const budgetperiodeÅr3 = currentYear + 3;
    const budgetperiodeÅr4 = currentYear + 4;
    const budgetperiode = budgetperiodeÅr1 + "-" + budgetperiodeÅr4;

    if (valgtDokument == "Budgetopfølgning") {
      organisationdata[0].forkortelse
      var udvalgsdata = await fetchAssets(configurl+organisationdata[0].forkortelse+".json");

      // Indsætter notattitel
      const notatTitel = context.document.body.insertParagraph(
        "Budgetopfølgning pr. " + valgtDokumentDetajle + " " + currentYear,
        Word.InsertLocation.start
      );
      notatTitel.style = "Brev/notat KORT (O1)";

      // Indsætter notatdetaljer
      context.document.body.paragraphs.getLast().select("End");
      var selection = context.document.getSelection();
      selection.insertParagraph("", "After");

      for (var i in notatDetaljer) {
        var tekst = context.document.body.insertParagraph(notatDetaljer[i], "End");
        tekst.set({
          lineUnitAfter: 0,
          lineUnitBefore: 0,
          spaceAfter: 0,
          spaceBefore: 0,
        });
        tekst.font.set({
          bold: true,
        });
        // Brugeren skriver videre i ikke-fed tekst.
        var tekstUdfyld = tekst.insertText("	", "End");
        tekstUdfyld.font.set({
          bold: false,
        });
      }

      // Sletter tom anden paragraph
      var paragraphs = context.document.body.paragraphs;
      paragraphs.load("items");
      await context.sync();
      paragraphs.items[1].delete();

      // Indsæter titel
      var titel = context.document.body.insertParagraph(
        valgtUdvalg +
          " – " +
          dokumentdata[0].langtNavn.toLowerCase() +
          " pr. " +
          valgtDokumentDetajle +
          " " +
          currentYear,
        Word.InsertLocation.end
      );
      titel.styleBuiltIn = "Heading1";

      // Indsætter dokumenttitel
      var dokumentegenskaber = context.document.properties.load("title");
      await context.sync();
      context.document.properties.set({
        title:
          valgtUdvalg +
          " – " +
          dokumentdata[0].langtNavn.toLowerCase() +
          " pr. " +
          valgtDokumentDetajle +
          " " +
          currentYear,
      });

      // Resume og tomt afsnit til at skrive i
      var underoverskrift = context.document.body.insertParagraph("Resumé", Word.InsertLocation.end);
      underoverskrift.styleBuiltIn = "Heading2";
      await context.sync();

      var underoverskrift = context.document.body.insertParagraph("", Word.InsertLocation.end);
      underoverskrift.styleBuiltIn = "Normal";
      await context.sync();

      /* Looper over bevillingsområder */
      for (var i in udvalgsdata.bevillingsområde) {
        
        /* Indsætter overskrift på bevillingsområde */
        var underoverskrift = context.document.body.insertParagraph("Bevilling "+udvalgsdata.bevillingsområde[i].navn, Word.InsertLocation.end);
        underoverskrift.styleBuiltIn = "Heading2";
        await context.sync();

        var emptyParagraph= context.document.body.insertParagraph("Alle beløb i tabellerne er angivet i mio. kr.", Word.InsertLocation.end);
        emptyParagraph.styleBuiltIn = "Normal";
        await context.sync();

        /* Looper over struktur i dokumentdata */
        for (var j in dokumentdata[0].struktur) {

          /* Toplevel eller ej */
          var toplevel = (j.indexOf("_s") > -1 ? false : true)  

          /* Indsætter overskrift hvis toplevel */
          if (toplevel & udvalgsdata.bevillingsområde[i].hasOwnProperty(j)) { 
            var underoverskrift = context.document.body.insertParagraph(dokumentdata[0].struktur[j].overskrift, Word.InsertLocation.end);
            underoverskrift.styleBuiltIn = "Heading3";
            await context.sync();

            var standardtekst = (dokumentdata[0].struktur[j].hasOwnProperty("standardtekst") ? dokumentdata[0].struktur[j].standardtekst : "");
            var parse = require("json-templates");
            var parseStandardtekst = parse(standardtekst);

            var indsatStandardtekst= context.document.body.insertParagraph(parseStandardtekst({lastYear: lastYear, omraade: udvalgsdata.bevillingsområde[i].navn}), Word.InsertLocation.end);
            indsatStandardtekst.styleBuiltIn = "Normal";
            await context.sync();

            /* Indsætter evt. tabel */
            if (dokumentdata[0].tabeller.hasOwnProperty(j) & udvalgsdata.bevillingsområde[i].hasOwnProperty(j)) {
              
              var parse = require("json-templates");
              var parseKolonner = parse(dokumentdata[0].tabeller[j].kolonner);

              var rowsFullArray = udvalgsdata.bevillingsområde[i][j];
              var rows = rowsFullArray.map(subArray => subArray[0])
              var rowsCount = rows.length;
              var columns = parseKolonner({lastYear: lastYear2, nextYear: currentYear});
              
              var parse = require("json-templates");
              var parseTabelBeskrivelse = parse(dokumentdata[0].tabeller[j].beskrivelse);
              var tabelBeskrivelse = parseTabelBeskrivelse({bevillingsomraade: udvalgsdata.bevillingsområde[i].navn});

              var data = buildTableMatrix(rows,columns,false,true,withData);

              var indsatTabel = context.document.body.insertTable(data.length, data[0].length, "End", data);
              indsatTabel.select();
              await context.sync();
              formatSelectedTable();

              insertBookmark(indsatTabel, dokumentdata[0].tabeller[k].kortnavn, i);

              var indsatFodnote = context.document.body.insertText(dokumentdata[0].tabeller[k].note, Word.InsertLocation.end);
              indsatFodnote.font.size = 9;
              indsatFodnote.font.italic = true;
              await context.sync();

              var emptyParagraph= context.document.body.insertParagraph("", Word.InsertLocation.end);
              emptyParagraph.styleBuiltIn = "Normal";
              await context.sync();

              tableAltBeskObj(udvalgsdata.bevillingsområde[i].navn + " - " + dokumentdata[0].tabeller[k].navn, tabelBeskrivelse);
            }
          }
          /* Ellers: Loop over substruktur  */
          if (toplevel == false) {
            
            var substruktur = j.substring(0, j.indexOf("_"));

            /* Looper over substrukturen hvis hovedstrukturen findes (f.eks. kun anlæg_s hvis anlæg) */
            if (udvalgsdata.bevillingsområde[i].hasOwnProperty(substruktur)) {

              /* Looper over alle substruktur-udfald i dokumenttype. Hvis den findes i udvalgsdata indsættes overskrift som defineret i dokumentdata */
              for (var k in dokumentdata[0].struktur[j]) {

                if (udvalgsdata.bevillingsområde[i][substruktur][0].hasOwnProperty(k)) {
                  /* Overskrift */
                  var underoverskrift = context.document.body.insertParagraph(dokumentdata[0].struktur[j][k].overskrift, Word.InsertLocation.end);
                  underoverskrift.styleBuiltIn = "Heading4";
                  await context.sync(); 

                  var standardtekst = (dokumentdata[0].struktur[j][k].hasOwnProperty("standardtekst") ? dokumentdata[0].struktur[j][k].standardtekst : "");

                  var emptyParagraph= context.document.body.insertParagraph(standardtekst, Word.InsertLocation.end);
                  emptyParagraph.styleBuiltIn = "Normal";
                  await context.sync();

                  /* Tabel */
                  if (dokumentdata[0].tabeller.hasOwnProperty(k)) {
                    var parse = require("json-templates");
                    var parseKolonner = parse(dokumentdata[0].tabeller[k].kolonner);

                    var rowsFullArray = udvalgsdata.bevillingsområde[i][substruktur][0][k];
                    var rows = rowsFullArray.map(subArray => subArray[0])
                    var rowsCount = rows.length;
                    var columns = parseKolonner({lastYear: lastYear2, nextYear: currentYear});
                    
                    var parse = require("json-templates");
                    var parseTabelBeskrivelse = parse(dokumentdata[0].tabeller[k].beskrivelse);
                    var tabelBeskrivelse = parseTabelBeskrivelse({bevillingsomraade: udvalgsdata.bevillingsområde[i].navn});

                    var includeProjects = ((k === "servicerammen" & udvalgsdata.bevillingsområde[i][substruktur][0].hasOwnProperty("projekter")) ? udvalgsdata.bevillingsområde[i][substruktur][0].projekter[0] : null);
                    
                    var data = buildTableMatrix(rows,columns,includeProjects,true,rowsFullArray);

                    var indsatTabel = context.document.body.insertTable(data.length, data[0].length, "End", data);
                    indsatTabel.select();
                    await context.sync();
                    formatSelectedTable();

                    insertBookmark(indsatTabel, dokumentdata[0].tabeller[k].kortnavn, i);

                    var indsatFodnote = context.document.body.insertText(dokumentdata[0].tabeller[k].note, Word.InsertLocation.end);
                    indsatFodnote.font.size = 9;
                    indsatFodnote.font.italic = true;
                    await context.sync();

                    var emptyParagraph= context.document.body.insertParagraph("", Word.InsertLocation.end);
                    emptyParagraph.styleBuiltIn = "Normal";
                    await context.sync();

                    tableAltBeskObj(udvalgsdata.bevillingsområde[i].navn + " - " + dokumentdata[0].tabeller[k].navn, tabelBeskrivelse);
                  } 

                  /* Underoverskrifter (hvis mere end en) */
                  if (rowsCount > 1) {
                    for (var rw = 0; rw <= rowsCount - 1; rw++) {
                      var underoverskrift = context.document.body.insertParagraph(rows[rw], Word.InsertLocation.end);
                      underoverskrift.styleBuiltIn = "Heading5";
                      
                      await context.sync();

                      var emptyParagraph= context.document.body.insertParagraph("", Word.InsertLocation.end);
                      emptyParagraph.styleBuiltIn = "Normal";
                      await context.sync();
                    }
                  }
                }
              }
            }
          }
        }        
      } 
      // Bevillingsansøgninger
      var underoverskrift = context.document.body.insertParagraph("Bevillingsansøgninger", Word.InsertLocation.end);
      underoverskrift.styleBuiltIn = "Heading2";
      await context.sync();

      // Afsøger hvilke rækker der skal være i tabellen ud fra hvad der faktisk anvendes i udvalget på tværs af bevillingsområder
      var rows = []
      // lopper over struktur i dokumentdata
      for (var j in dokumentdata[0].struktur) {
        var toplevel = (j.indexOf("_s") > -1 ? false : true)  
        var substruktur = j.substring(0, j.indexOf("_"));
        // Kun substruktuerer er relevante (drift_s og anlæg_s)
        if (toplevel == false) {
          // Loop over substruktur
          for (var k in dokumentdata[0].struktur[j]) {
            // Loop over bevillingsområder
            for (var i in udvalgsdata.bevillingsområde) {
              // Hvis substruktur findes i bevillingsområde
              if (udvalgsdata.bevillingsområde[i].hasOwnProperty(substruktur)) {
                // Hvis relevant indhold fra substruktureb findes for bevillingsområdet
                if (udvalgsdata.bevillingsområde[i][substruktur][0].hasOwnProperty(k)) {
                  // Tilføjes til listen over rækker, hvis den ikke allerede findes   
                  if (!rows.includes(dokumentdata[0].struktur[j][k].overskrift)) { 
                    // rows.push(dokumentdata[0].tabeller.bevillingsansøgninger.rækker[k]);
                    rows.push(dokumentdata[0].struktur[j][k].overskrift);           
                  }
                }
              }
            }
          }
        }
      }
      // Indsætter tabel for bevillingsansøgninger
      var parse = require("json-templates");
      var parseKolonner = parse(dokumentdata[0].tabeller.bevillingsansøgninger.kolonner);

      var rowsCount = rows.length;
      var columns = parseKolonner({currentYear: currentYear, budgetperiode1: budgetperiodeÅr1, budgetperiode2: budgetperiodeÅr2, budgetperiode3: budgetperiodeÅr3});
      
      var tabelBeskrivelse = dokumentdata[0].tabeller.bevillingsansøgninger.beskrivelse;
      

      // var data = buildTableMatrix(rows,columns,null,true,rows,1);

      var data = [columns];
  
      for (var i in rows) {
        var rowBuild = [rows[i]];
        for (var j in columns-1){
          rowBuild.push("");
        }
        data.push(rowBuild);
      }
      data.push(["I alt","","","","",""]) 
      console.log(data)

      var indsatTabel = context.document.body.insertTable(data.length, data[0].length, "End", data);
      indsatTabel.select();
      await context.sync();
      formatSelectedTable();

      insertBookmark(indsatTabel, dokumentdata[0].tabeller.bevillingsansøgninger.kortnavn, "");

      var indsatFodnote = context.document.body.insertText(dokumentdata[0].tabeller.bevillingsansøgninger.note, Word.InsertLocation.end);
      indsatFodnote.font.size = 9;
      indsatFodnote.font.italic = true;
      await context.sync();

      var emptyParagraph= context.document.body.insertParagraph("", Word.InsertLocation.end);
      emptyParagraph.styleBuiltIn = "Normal";
      await context.sync();

      tableAltBeskObj("Bevillingsansøgninger", tabelBeskrivelse);

      /* Underoverskrifter (hvis mere end en) */
      if (rowsCount > 1) {
        for (var rw = 0; rw <= rowsCount - 1; rw++) {
          var underoverskrift = context.document.body.insertParagraph(rows[rw], Word.InsertLocation.end);
          underoverskrift.styleBuiltIn = "Heading3";
          
          await context.sync();

          var emptyParagraph= context.document.body.insertParagraph("", Word.InsertLocation.end);
          emptyParagraph.styleBuiltIn = "Normal";
          await context.sync();
        }
      }

      // Custom tabeller
      if (udvalgsdata.hasOwnProperty("customTabeller")) {
        if (udvalgsdata.customTabeller.hasOwnProperty("budgetopfølgning")) {
          var indsatteTabeller = {}
          for (var ct in udvalgsdata.customTabeller.budgetopfølgning) {
            var placering = udvalgsdata.customTabeller.budgetopfølgning[ct].placering;
            var placeringStyle = udvalgsdata.customTabeller.budgetopfølgning[ct].placeringStyle;

            // Identificerer placeringen i dokumentet ud fra placering og placeringStyle
            var paragraphs = context.document.body.paragraphs;
            paragraphs = paragraphs.load("items");
            await context.sync();
            for (var paragraph in paragraphs.items) {  
              if (paragraphs.items[paragraph]._Te == placering & paragraphs.items[paragraph]._Sty == placeringStyle) { 

                // Placering
                var placering = udvalgsdata.customTabeller.budgetopfølgning[ct].placeringOmkringAfsnit

                // Identifikation af afsnit
                if (placering == "Før") {
                  var currentParagraph = Number(paragraph)-1;
                  currentParagraph = currentParagraph.toString();
                  var nextParagraph = paragraph;
                } else if (placering == "Efter") {
                  var currentParagraph = paragraph;
                  var nextParagraph = Number(paragraph)+1 
                  nextParagraph = nextParagraph.toString();
                } 

                // Henter data til tabellen
                var rowsFullArray = udvalgsdata.customTabeller.budgetopfølgning[ct].rækker;
                var rows = rowsFullArray.map(subArray => subArray[0])
                var rowsCount = rows.length;
                var columns = udvalgsdata.customTabeller.budgetopfølgning[ct].kolonner;
                var tabelBeskrivelse = udvalgsdata.customTabeller.budgetopfølgning[ct].beskrivelse;
                var tabelnr = udvalgsdata.customTabeller.budgetopfølgning[ct].tabelnr;
                var insertTotal = udvalgsdata.customTabeller.budgetopfølgning[ct].total;
                var dataArk = udvalgsdata.customTabeller.budgetopfølgning[ct].dataArk;

                // Bygger tabelmatrice
                var data = buildTableMatrix(rows,columns,null,insertTotal,rowsFullArray,dataArk);
                
                // Indsætter indledende tekst og evt. afsnitsoverskrift
                if (placering === "Efter") {
                  paragraphs.items[currentParagraph].select();
                  await context.sync();
                  var indsatTekst = paragraphs.items[currentParagraph].insertParagraph(tabelBeskrivelse, "After");
                  indsatTekst.styleBuiltIn = "Normal";
                
                  if (udvalgsdata.customTabeller.budgetopfølgning[ct].nytAfsnit === true) {
                    var indsatAfsnit = paragraphs.items[currentParagraph].insertParagraph(udvalgsdata.customTabeller.budgetopfølgning[ct].nytAfsnitNavn,"After");
                    indsatAfsnit.styleBuiltIn = udvalgsdata.customTabeller.budgetopfølgning[ct].nytAfsnitStyle;
                  }
                } else if (placering === "Før") {
                  if (udvalgsdata.customTabeller.budgetopfølgning[ct].nytAfsnit === true) {
                    var indsatAfsnit = paragraphs.items[currentParagraph].insertParagraph(udvalgsdata.customTabeller.budgetopfølgning[ct].nytAfsnitNavn,"After");
                    indsatAfsnit.styleBuiltIn = udvalgsdata.customTabeller.budgetopfølgning[ct].nytAfsnitStyle;
                  }
                
                  paragraphs.items[currentParagraph].select();
                  await context.sync();
                  var indsatTekst = paragraphs.items[currentParagraph].insertParagraph(tabelBeskrivelse, "After");
                  indsatTekst.styleBuiltIn = "Normal";
                }
                await context.sync();

                // Indsætter tabel
                paragraphs.items[nextParagraph].select();

                // Spacing before has been set to some value somewhere - god knows where - setting to 0 as to not mess with the table
                paragraphs.items[nextParagraph].spaceBefore = 0;
                
                await context.sync();
                indsatteTabeller[ct] = paragraphs.items[nextParagraph].insertTable(data.length, data[0].length, "Before", data);
                console.log("indsatteTabeller: ", ct, indsatteTabeller)

                // Formaterer tabel
                await styleTable(indsatteTabeller[ct]); // this should work async but it is called synchronously because indsatteTabeller is being messed with.

                // // Indsætter bogmærke
                insertBookmark(indsatteTabeller[ct], udvalgsdata.customTabeller.budgetopfølgning[ct].kortnavn, i);
                
                // Indsætter fodnote
                await context.sync();
                if (placering === "Efter") {
                    paragraphs.items[nextParagraph].select(); 
                    var indsatFodnote = paragraphs.items[nextParagraph].insertText(udvalgsdata.customTabeller.budgetopfølgning[ct].note,"End");
                } else if (placering === "Før") {
                    paragraphs.items[nextParagraph].select();
                    await context.sync(); 
                    var indsatAfsnit = paragraphs.items[nextParagraph].insertParagraph("", "Before");
                    indsatAfsnit.styleBuiltIn = "Normal";
                    indsatAfsnit.select();
                    var indsatFodnote = indsatAfsnit.insertText(udvalgsdata.customTabeller.budgetopfølgning[ct].note,"Start");

                }
                indsatFodnote.font.size = 9;
                indsatFodnote.font.italic = true; 
                await context.sync(); 


                // Indsætter tomt afsnit efter afsnittet CT blev indsat 
                if (placering === "Efter") {
                  paragraphs.items[nextParagraph].select();
                  await context.sync();
                  var emptyParagraph = paragraphs.items[nextParagraph].insertParagraph("", "After");
                  emptyParagraph.styleBuiltIn = "Normal";
                  await context.sync();

                  paragraphs.items[currentParagraph].select();
                  await context.sync();
                  var emptyParagraph = paragraphs.items[currentParagraph].insertParagraph("", "After");
                  emptyParagraph.styleBuiltIn = "Normal";
                  await context.sync();
                }
                if (placering === "Før") {
                  paragraphs.items[nextParagraph].select();
                  await context.sync();
                  var emptyParagraph = paragraphs.items[nextParagraph].insertParagraph("", "Before");
                  emptyParagraph.styleBuiltIn = "Normal";
                  await context.sync();
                }
                

                // // Indsætter tabelbeskrivelse i dokumentkommentarer
                tableAltBeskObj(udvalgsdata.customTabeller.budgetopfølgning[ct].navn, tabelBeskrivelse, tabelnr); 
              }
            }
          }
        }   
      }
    }
    // Budgetbemærkninger del 1
    if (valgtDokument == "Budgetbemærkninger del 1") {
      //  Fetcher organisationsdata igen
      var organisation = await fetchAssets(configurl+"organisation.json");
      console.log("organisation: ", organisation);
      var inputdata = organisation.filter((obj) => obj.udvalg == valgtUdvalg);
      inputdata = inputdata[0].dokumenter.filter((obj) => obj.navn == valgtDokument);
      inputdata = inputdata[0].bevillingsområde.filter((obj) => obj.navn == valgtBevilling);
      console.log("inputdata: ", inputdata);

      // tabelindhold
      var tabeller = inputdata[0].tabeller;
      var faktaoverskrift = tabeller[0].faktaOverskrift;
      var fakta = tabeller[0].fakta;
      var politikker = tabeller[0].politikker;
      console.log("tabeller: ", tabeller);

      // Indsætter dokumenttitel
      var dokumentegenskaber = context.document.properties.load("title");
      await context.sync();
      context.document.properties.set({
        title: valgtUdvalg + " - " + valgtBevilling + " – " + langtNavn.toLowerCase() + " - " + budgetperiode,
      });
      await context.sync();

      // Sidehoved
      // Rydder sidehoved i startskabelonen
      rydSidehoved();

      var header = context.document.sections
        .getFirst()
        .getHeader(Word.HeaderFooterType.primary)
        .insertParagraph(valgtUdvalg + " - " + valgtBevilling, "Start");
      header.font.size = 18;
      header.alignment = "Centered";
      var header2 = context.document.sections
        .getFirst()
        .getHeader(Word.HeaderFooterType.primary)
        .insertParagraph(langtNavn, "End");
      header2.font.size = 18;
      header2.alignment = "Centered";

      // Indsætter sektioner og undersektioner
      for (var sektion in sektioner) {
        context.document.body.paragraphs.getLast().select("End");

        // Sektioner og undersektioner
        await indsætSektion(sektioner[sektion]);
        await context.sync();

        await indsætUndersektioner(sektioner[sektion], undersektioner[sektion], "-", "Heading3");
        await context.sync();
      }

      // Indsætter indhold i rammestrukturen
      var contentControls = context.document.contentControls;
      contentControls.load("id");
      await context.sync();

      // Indsætter tabel til fakta og politikker
      rækker = Math.max(fakta.length, politikker.length + 2);
      var data = [];
      data.push([faktaoverskrift, "", "", "Politikker"]);

      for (var række = 0; række < rækker; række++) {
        data.push([fakta[række], "", "", politikker[række]]);
      }
      data[rækker - 1][3] = "Se Randers Kommunes politikker på";
      data[rækker][3] = "www.randers.dk/demokrati/politikker/";

      var ccNavn = "1. Beskrivelse af området";
      var targetCC = genContentControls.indexOf(ccNavn);
      var indsatTabel = contentControls.items[targetCC].insertTable(rækker + 1, 4, "End", data);

      tableAltBeskObj("Fakta og politikker", "Fakta og politikker");

      // Styler tabel - skal flyttes til utils
      indsatTabel.headerRowCount = 1;
      indsatTabel.font.bold = false;
      indsatTabel.font.size = 11;
      indsatTabel.font.name = "Calibri";
      indsatTabel.font.color = "#000000";

      // Loop over alle rækker
      var rækker = indsatTabel.rows;
      rækker.load("items");
      await context.sync();
      for (var i = 0; i < rækker.items.length; i++) {
        rækker.items[i].verticalAlignment = "Top"; 

        if (i == 0) {
          rækker.items[i].font.bold = true;
        }

        // Loop over celler
        var celler = rækker.items[i].cells;
        celler.load("items");
        await context.sync();
        for (var k = 0; k < celler.items.length; k++) {
          // Styler kolonne 0, 1 og 3
          if (k != 2) {
            celler.items[k].shadingColor = "#DDEBF7";
          }
          // Sætter padding
          celler.items[k].setCellPadding("Top", 1);
          celler.items[k].setCellPadding("Bottom", 1);

          // Højrestiller kolonne 1
          if (k == 1) {
            celler.items[k].horizontalAlignment = "Right";
          }
          // Indstiller bredden
          // 28.35 points pr. centimer, 17 cm sidebredde. = 491,95 points
          if (k == 0) {
            celler.items[k].columnWidth = 180;
          }
          if (k == 1) {
            celler.items[k].columnWidth = 40;
          }
          if (k == 2) {
            celler.items[k].columnWidth = 42;
          }
          if (k == 3) {
            celler.items[k].columnWidth = 220;
          }
          if ((i == rækker.items.length - 1) & (k == 3)) {
            celler.items[k].verticalAlignment = "Top";
            // VIRKER IKKE...
            /*
            const cell=celler.items[k]
            cell.insertHtml(
              `<a href="Randers.dk/politikker">Randers.dk/politikker</a>`,
              Word.InsertLocation.replace
            );
            */
          }
        }
      }

      // Fjerner alle rammer
      var borderLocation = Word.BorderLocation.all;
      var border = indsatTabel.getBorder(borderLocation);
      border.set({ type: "none" });
      await context.sync();

      // Indsætter tabel vedr. drift
      var ccNavn = "2. Hovedtal - 2.1 Drift";
      var targetCC = genContentControls.indexOf(ccNavn);

      // Indledende tekst
      const parse = require("json-templates");
      const templateBeskrivelse = parse(tabeller[1].beskrivelse);
      console.log(templateBeskrivelse({ fra: budgetperiodeÅr1, til: budgetperiodeÅr4 }));

      const indsatTabelbeskrivelse = contentControls.items[targetCC].insertParagraph(
        templateBeskrivelse({ fra: budgetperiodeÅr1, til: budgetperiodeÅr4 }),
        "Start"
      );
      await context.sync();

      var rækkerServicerammen = tabeller[1].rækkerServicerammen;
      var rækkerUdenForServicerammen = tabeller[1].rækkerUdenForServicerammen;
      var k1r1 = tabeller[1].k1r1;
      var tabelnr = tabeller[1].nr;
      var rækkerServicerammenAntal = rækkerServicerammen.length;
      var rækkerUdenForServicerammenAntal = rækkerUdenForServicerammen.length;
      var kolonnerAntal = 5;
      var fodnote = tabeller[1].note;

      var data = [[k1r1, budgetperiodeÅr1, budgetperiodeÅr2, budgetperiodeÅr3, budgetperiodeÅr4]];

      // Servicerammen
      data.push(["Servicerammen", "", "", "", ""]);
      for (var j in rækkerServicerammen) {
        var række = [rækkerServicerammen[j]];
        for (var i = 1; i <= kolonnerAntal - 1; i++) {
          række.push("");
        }
        data.push(række);
      }
      // Uden for servicerammen
      data.push(["Uden for servicerammen", "", "", "", ""]);
      for (var j in rækkerUdenForServicerammen) {
        var række = [rækkerUdenForServicerammen[j]];
        for (var j = 1; j <= kolonnerAntal - 1; j++) {
          række.push("");
        }
        data.push(række);
      }
      data.push(["I alt", "", "", "", ""]);

      var indsatTabel = contentControls.items[targetCC].insertTable(
        rækkerServicerammenAntal + rækkerUdenForServicerammenAntal + 4,
        kolonnerAntal,
        "End",
        data
      );
      //console.table(data)
      await context.sync();
      tabelAddOns(indsatTabel, contentControls.items[targetCC], 0, fodnote);
      await context.sync();
      tableAltBeskObj(tabeller[1].navn, templateBeskrivelse({ fra: budgetperiodeÅr1, til: budgetperiodeÅr4 }));
      await context.sync();
      contentControls.items[targetCC].insertParagraph("2.1.1 Servicerammen", "End").styleBuiltIn = "Heading3";
      contentControls.items[targetCC].insertParagraph("", "End").styleBuiltIn = "Normal";
      contentControls.items[targetCC].insertParagraph("2.1.2 Uden for servicerammen", "End").styleBuiltIn = "Heading3";
      contentControls.items[targetCC].insertParagraph("", "End").styleBuiltIn = "Normal";

      formaterTabellerBB("tabel-1");

      // Indsætter tabel vedr. anlæg
      var ccNavn = "2. Hovedtal - 2.2 Anlæg";
      var targetCC = genContentControls.indexOf(ccNavn);

      // Indledende tekst
      const parse2 = require("json-templates");
      const templateBeskrivelse2 = parse2(tabeller[2].beskrivelse);
      var indsatTabelbeskrivelse2 = contentControls.items[targetCC].insertParagraph(
        templateBeskrivelse2({ fra: budgetperiodeÅr1, til: budgetperiodeÅr4 }),
        "Start"
      );
      await context.sync();

      var rækker = tabeller[2].rækker;
      var rækkerAntal = tabeller[2].rækker.length;
      var k1r1 = tabeller[2].k1r1;
      var tabelnr = tabeller[2].nr;
      var kolonnerAntal = 5;
      const parse3 = require("json-templates");
      const templateBeskrivelse3 = parse3(tabeller[2].note);

      var data = [[k1r1, budgetperiodeÅr1, budgetperiodeÅr2, budgetperiodeÅr3, budgetperiodeÅr4]];

      for (var j in rækker) {
        var række = [rækker[j]];
        for (var i = 1; i <= kolonnerAntal - 1; i++) {
          række.push("");
        }
        data.push(række);
      }

      var indsatTabel = contentControls.items[targetCC].insertTable(rækkerAntal + 1, kolonnerAntal, "End", data);
      await context.sync();
      tabelAddOns(
        indsatTabel,
        contentControls.items[targetCC],
        0,
        templateBeskrivelse3({ fra: budgetperiodeÅr1, til: budgetperiodeÅr4 })
      );
      await context.sync();
      tableAltBeskObj(tabeller[2].navn, templateBeskrivelse2({ fra: budgetperiodeÅr1, til: budgetperiodeÅr4 }));
      await context.sync();

      formaterTabellerBB("tabel-2");
    }
    if (valgtDokument == "Budgetbemærkninger del 2") {
      //  Fetcher organisationsdata igen
      var organisation = await fetchAssets(configurl+"organisation.json");
      console.log("organisation: ", organisation);
      var inputdata = organisation.filter((obj) => obj.udvalg == valgtUdvalg);
      inputdata = inputdata[0].dokumenter.filter((obj) => obj.navn == valgtDokument);
      inputdata = inputdata[0].bevillingsområde.filter((obj) => obj.navn == valgtBevilling);
      console.log("inputdata: ", inputdata);

      // tabelindhold
      var tabeller = inputdata[0].tabeller;
      console.log("tabeller: ", tabeller);

      // Indsætter dokumenttitel
      var dokumentegenskaber = context.document.properties.load("title");
      await context.sync();
      context.document.properties.set({
        title: valgtUdvalg + " - " + valgtBevilling + " – " + langtNavn.toLowerCase() + " - " + budgetperiode,
      });
      await context.sync();

      // Sidehoved
      // Rydder sidehoved i startskabelonen
      rydSidehoved();

      await context.sync();

      var header = context.document.sections
        .getFirst()
        .getHeader(Word.HeaderFooterType.primary)
        .insertParagraph(valgtUdvalg + " - " + valgtBevilling, "Start");
      header.font.size = 18;
      header.alignment = "Centered";
      var header2 = context.document.sections
        .getFirst()
        .getHeader(Word.HeaderFooterType.primary)
        .insertParagraph(langtNavn, "End");
      header2.font.size = 18;
      header2.alignment = "Centered";

      // Indsætter sektioner og undersektioner
      for (var sektion in sektioner) {
        context.document.body.paragraphs.getLast().select("End");

        // Sektioner og undersektioner
        await indsætSektion(sektioner[sektion]);
        await context.sync();

        await indsætUndersektioner(
          sektioner[sektion],
          undersektioner[sektion],
          "-",
          "Heading3",
          budgetperiodeÅr1,
          budgetperiodeÅr4
        );
        await context.sync();
      }

      await context.sync();

      // Indsætter indhold i rammestrukturen
      var contentControls = context.document.contentControls;
      contentControls.load("id");
      await context.sync();

      // Tabel i afsnit 1
      var ccNavn = "1. Supplerende beskrivelse af området";
      var targetCC = genContentControls.indexOf(ccNavn);

      // Indledende tekst
      const parse = require("json-templates");
      const templateBeskrivelse = parse(tabeller[0].beskrivelse);
      console.log(templateBeskrivelse({ fra: budgetperiodeÅr1 }));

      const indsatTabelbeskrivelse = contentControls.items[targetCC].insertParagraph(
        templateBeskrivelse({ fra: budgetperiodeÅr1 }),
        "Start"
      );
      await context.sync();

      var rækkerServicerammen = tabeller[0].rækkerServicerammen;
      var rækkerUdenForServicerammen = tabeller[0].rækkerUdenForServicerammen;
      var k1r1 = tabeller[0].k1r1;
      var tabelnr = tabeller[0].nr;
      var rækkerServicerammenAntal = rækkerServicerammen.length;
      var rækkerUdenForServicerammenAntal = rækkerUdenForServicerammen.length;
      var kolonnerAntal = 4;
      var fodnote = tabeller[0].note;

      var data = [
        [
          k1r1,
          "Udgift \n".concat(budgetperiodeÅr1),
          "Indtægt \n".concat(budgetperiodeÅr1),
          "Netto \n".concat(budgetperiodeÅr1),
        ],
      ];

      // Servicerammen
      data.push(["Servicerammen", "", "", ""]);
      for (var j in rækkerServicerammen) {
        var række = [rækkerServicerammen[j]];
        for (var i = 1; i <= kolonnerAntal - 1; i++) {
          række.push("");
        }
        data.push(række);
      }
      // Uden for servicerammen
      data.push(["Uden for servicerammen", "", "", ""]);
      for (var j in rækkerUdenForServicerammen) {
        var række = [rækkerUdenForServicerammen[j]];
        for (var j = 1; j <= kolonnerAntal - 1; j++) {
          række.push("");
        }
        data.push(række);
      }
      data.push(["I alt", "", "", ""]);
      console.table(data);

      var indsatTabel = contentControls.items[targetCC].insertTable(
        rækkerServicerammenAntal + rækkerUdenForServicerammenAntal + 4,
        kolonnerAntal,
        "End",
        data
      );
      //console.table(data)
      await context.sync();
      tabelAddOns(indsatTabel, contentControls.items[targetCC], 0, fodnote);

      await context.sync();
      tableAltBeskObj(tabeller[0].navn, templateBeskrivelse({ fra: budgetperiodeÅr1 }));
      await context.sync();

      formaterTabellerBB("tabel-0");

      var row_names = rækkerServicerammen.concat(rækkerUdenForServicerammen);
      // Indsætter undersektioner
      var ccNavn = "1. Supplerende beskrivelse af området - 1.1 Servicerammen";
      await indsætSektionerICC(ccNavn, rækkerServicerammen, "Heading4", true, "1.1");
      await context.sync();

      var ccNavn = "1. Supplerende beskrivelse af området - 1.2 Uden for servicerammen";
      await indsætSektionerICC(ccNavn, rækkerUdenForServicerammen, "Heading4", true, "1.2");
      await context.sync();

      // Tabel i afsnit 3
      var ccNavn = "3. Ændringer på området";
      var targetCC = genContentControls.indexOf(ccNavn);

      var indledning =
        "På baggrund af budgetforudsætningerne viser tabellen, hvilke ændringer der er indarbejdet i budgettet siden udgangspunktet fra sidste års vedtagne budget.";
      var indsatIndledning = contentControls.items[targetCC].insertParagraph(indledning, "Start");
      await context.sync();

      var budgetperiodeÅr0 = budgetperiodeÅr1 - 1;
      var budgetperiodeÅr_1 = budgetperiodeÅr0 - 1;
      var data = [
        [
          "Ændringer siden budget ".concat(budgetperiodeÅr0).concat(" (mio. kr.)"),
          budgetperiodeÅr1,
          budgetperiodeÅr2,
          budgetperiodeÅr3,
          budgetperiodeÅr4,
        ],
      ];
      data.push([
        "Udgangspunkt ".concat(budgetperiodeÅr0).concat("-budget (").concat(budgetperiodeÅr1).concat("-priser)"),
        "",
        "",
        "",
        "",
      ]);
      data.push(
        ["Budgetaftale ".concat(budgetperiodeÅr1).concat("-").concat(budgetperiodeÅr4), "", "", "", ""],
        ["[Indsæt rækker efter behov]", "", "", "", ""],
        ["", "", "", "", ""]
      );
      data.push(
        ["Demografi", "", "", "", ""], 
        ["[Indsæt rækker efter behov]", "", "", "", ""], 
        ["", "", "", "", ""]);
      data.push(
        ["Budgetaftale tidligere år", "", "", "", ""],
        ["[Indsæt rækker efter behov]", "", "", "", ""],
        ["", "", "", "", ""]
      );
      data.push(
        ["Tillægsbevillinger og omplaceringer", "", "", "", ""],
        ["[Indsæt rækker efter behov]", "", "", "", ""],
        ["", "", "", "", ""]
      );
      data.push(
        ["PL og øvrige ændringer", "", "", "", ""],
        ["[Indsæt rækker efter behov]", "", "", "", ""],
        ["", "", "", "", ""]
      );
      data.push(["I alt", "", "", "", ""]);
      // console.table(data)

      var indsatTabel = contentControls.items[targetCC].insertTable(data.length, data[0].length, "End", data);

      await context.sync();
      tableAltBeskObj("Ændringer på området", indledning);

      formaterTabellerBB("tabel-1");
      await context.sync();

      // Tabel i afsnit 5
      var ccNavn = "5. Anlægsprojekter";
      var targetCC = genContentControls.indexOf(ccNavn);

      const parseIndledning = require("json-templates");
      var templateIndledning = parseIndledning(
        "Som en del af budgetvedtagelsen for {{fra}}-{{til}}, blev den 10-årige investeringsplan godkendt. I tabellen   ses de år, der ligger uden for budgetperioden."
      );
      var indsatIndledning = contentControls.items[targetCC].insertParagraph(
        templateIndledning({ fra: budgetperiodeÅr1, til: budgetperiodeÅr4 }),
        "Start"
      );
      await context.sync();

      // Henter oplysninger om investeringsplanens sidste år fra dokumentertype.json
      let investeringsplanSidsteÅr = dokumentdata[0].investeringsplanSidsteÅr;
      console.log(investeringsplanSidsteÅr);

      var data0 = ["10-årig investeringsplan (mio. kr.)"];
      var data1 = ["[Indsæt rækker efter behov]"];
      var data2 = ["I alt"];
      for (var i = budgetperiodeÅr4 + 1; i <= investeringsplanSidsteÅr; i++) {
        data0.push(i);
        data1.push("");
        data2.push("");
      }
      var data = [data0, data1, data2];

      var indsatTabel = contentControls.items[targetCC].insertTable(data.length, data[0].length, "End", data);

      await context.sync();
      tableAltBeskObj("10-årig investeringsplan", templateIndledning({ fra: budgetperiodeÅr1, til: budgetperiodeÅr4 }));

      formaterTabellerBB("tabel-2");
      await context.sync();

      // Ny side
      contentControls.items[targetCC].insertBreak(Word.BreakType.page, "End");
      await context.sync();

      // Anlægsprojekter (eksempel)
      var ccNavn = "5. Anlægsprojekter - Anlægsprojekt: [Navn på anlægsprojekt]";
      var targetCC = genContentControls.indexOf(ccNavn);
      contentControls.items[targetCC].insertParagraph("Bevillingsprogramnummer: [xxxxxxxxxx]", "Start");
      await context.sync();

      // Rådighedsbeløb
      var tabelOverskrift = contentControls.items[targetCC].insertParagraph(
        "Rådighedsbeløb (" + budgetperiodeÅr1 + "-priser, 1000 kr.)",
        "End"
      );
      tabelOverskrift.styleBuiltIn = "Heading4";
      var blanktAfsnit = contentControls.items[targetCC].insertParagraph("", "End");
      blanktAfsnit.styleBuiltIn = "Normal";
      var data = [
        [
          "Type",
          "Før " + budgetperiodeÅr1 + " (årets priser)",
          budgetperiodeÅr1,
          budgetperiodeÅr2,
          budgetperiodeÅr3,
          budgetperiodeÅr4,
          "I alt",
        ],
      ];
      data.push(["Udgifter", "", "", "", "", "", ""]);
      data.push(["Indtægter", "", "", "", "", "", ""]);
      data.push(["I alt", "", "", "", "", "", ""]);

      var indsatTabel = contentControls.items[targetCC].insertTable(data.length, data[0].length, "End", data);

      await context.sync();
      tableAltBeskObj(
        "Rådighedsbeløb (" + budgetperiodeÅr1 + "-priser, 1000 kr.)",
        "Rådighedsbeløb (" + budgetperiodeÅr1 + "-priser, 1000 kr.)"
      );

      formaterTabellerBB("tabel-3");
      await context.sync();

      // Anlægsbevillinger
      var tabelOverskrift = contentControls.items[targetCC].insertParagraph(
        "Anlægsbevilling (årets priser, 1000 kr.)",
        "End"
      );
      tabelOverskrift.styleBuiltIn = "Heading4";
      var blanktAfsnit = contentControls.items[targetCC].insertParagraph("", "End");
      blanktAfsnit.styleBuiltIn = "Normal";

      var data = [["Dato", "Udgifter", "Indtægter", "Netto", "Bemærkninger"]];
      data.push(["[Indsæt rækker efter behov]", "", "", "", ""]);
      data.push(["I alt", "", "", "", ""]);

      var indsatTabel = contentControls.items[targetCC].insertTable(data.length, data[0].length, "End", data);

      await context.sync();
      tableAltBeskObj("Anlægsbevilling (årets priser, 1000 kr.)", "Anlægsbevilling (årets priser, 1000 kr.)");

      formaterTabellerBB("tabel-4");
      await context.sync();
    }
    if (valgtDokument == "Regnskabsbemærkninger") {
      /* Loader JSON-fil for relevant udvalg */
      organisationdata[0].forkortelse
      var udvalgsdata = await fetchAssets(configurl+organisationdata[0].forkortelse+".json");

      /* indsætter titel */
      var notatTitel = context.document.body.insertParagraph(valgtUdvalg, Word.InsertLocation.start);
      notatTitel.styleBuiltIn = "Heading1";
      await context.sync();

      var emptyParagraph= context.document.body.insertParagraph("", Word.InsertLocation.end);
      emptyParagraph.styleBuiltIn = "Normal";
      await context.sync();


      // Indsætter dokumenttitel
      var dokumentegenskaber = context.document.properties.load("title");
      await context.sync();
      context.document.properties.set({
        title:
          dokumentdata[0].langtNavn +
          " - " +
          valgtUdvalg +
          " – " +
          lastYear,
      });

      /* Looper over bevillingsområder */
      for (var i in udvalgsdata.bevillingsområde) {
        
        /* Indsætter overskrift på bevillingsområde */
        var underoverskrift = context.document.body.insertParagraph("Regnskabsresultat på "+udvalgsdata.bevillingsområde[i].navn, Word.InsertLocation.end);
        underoverskrift.styleBuiltIn = "Heading2";
        await context.sync();

        var emptyParagraph= context.document.body.insertParagraph("Alle beløb i tabellerne er angivet i mio. kr.", Word.InsertLocation.end);
        emptyParagraph.styleBuiltIn = "Normal";
        await context.sync();

        /* Looper over struktur i dokumentdata */
        for (var j in dokumentdata[0].struktur) {

          /* Toplevel eller ej */
          var toplevel = (j.indexOf("_s") > -1 ? false : true)  

          /* Indsætter overskrift hvis toplevel */
          if (toplevel & udvalgsdata.bevillingsområde[i].hasOwnProperty(j)) { 
            var underoverskrift = context.document.body.insertParagraph(dokumentdata[0].struktur[j].overskrift, Word.InsertLocation.end);
            underoverskrift.styleBuiltIn = "Heading3";
            await context.sync();

            var standardtekst = (dokumentdata[0].struktur[j].hasOwnProperty("standardtekst") ? dokumentdata[0].struktur[j].standardtekst : "");
            var parse = require("json-templates");
            var parseStandardtekst = parse(standardtekst);

            var indsatStandardtekst= context.document.body.insertParagraph(parseStandardtekst({lastYear: lastYear, omraade: udvalgsdata.bevillingsområde[i].navn}), Word.InsertLocation.end);
            indsatStandardtekst.styleBuiltIn = "Normal";
            await context.sync();

            /* Indsætter evt. tabel */
            if (dokumentdata[0].tabeller.hasOwnProperty(j) & udvalgsdata.bevillingsområde[i].hasOwnProperty(j)) {
              
              var parse = require("json-templates");
              var parseKolonner = parse(dokumentdata[0].tabeller[j].kolonner);

              var rowsFullArray = udvalgsdata.bevillingsområde[i][j];
              var rows = rowsFullArray.map(subArray => subArray[0])
              var rowsCount = rows.length;
              var columns = parseKolonner({lastYear: lastYear2, nextYear: currentYear});
              
              var parse = require("json-templates");
              var parseTabelBeskrivelse = parse(dokumentdata[0].tabeller[j].beskrivelse);
              var tabelBeskrivelse = parseTabelBeskrivelse({bevillingsomraade: udvalgsdata.bevillingsområde[i].navn});

              var data = buildTableMatrix(rows,columns,false,true,withData);

              var indsatTabel = context.document.body.insertTable(data.length, data[0].length, "End", data);
              indsatTabel.select();
              await context.sync();
              formatSelectedTable();

              insertBookmark(indsatTabel, dokumentdata[0].tabeller[k].kortnavn, i);

              var indsatFodnote = context.document.body.insertText(dokumentdata[0].tabeller[k].note, Word.InsertLocation.end);
              indsatFodnote.font.size = 9;
              indsatFodnote.font.italic = true;
              await context.sync();

              var emptyParagraph= context.document.body.insertParagraph("", Word.InsertLocation.end);
              emptyParagraph.styleBuiltIn = "Normal";
              await context.sync();

              tableAltBeskObj(udvalgsdata.bevillingsområde[i].navn + " - " + dokumentdata[0].tabeller[k].navn, tabelBeskrivelse);
            }
          }
          /* Ellers: Loop over substruktur  */
          if (toplevel == false) {
            
            var substruktur = j.substring(0, j.indexOf("_"));

            /* Looper over substrukturen hvis hovedstrukturen findes (f.eks. kun anlæg_s hvis anlæg) */
            if (udvalgsdata.bevillingsområde[i].hasOwnProperty(substruktur)) {

              /* Looper over alle substruktur-udfald i dokumenttype. Hvis den findes i udvalgsdata indsættes overskrift som defineret i dokumentdata */
              for (var k in dokumentdata[0].struktur[j]) {

                if (udvalgsdata.bevillingsområde[i][substruktur][0].hasOwnProperty(k)) {
                  /* Overskrift */
                  var underoverskrift = context.document.body.insertParagraph(dokumentdata[0].struktur[j][k].overskrift, Word.InsertLocation.end);
                  underoverskrift.styleBuiltIn = "Heading4";
                  await context.sync(); 

                  var standardtekst = (dokumentdata[0].struktur[j][k].hasOwnProperty("standardtekst") ? dokumentdata[0].struktur[j][k].standardtekst : "");

                  var emptyParagraph= context.document.body.insertParagraph(standardtekst, Word.InsertLocation.end);
                  emptyParagraph.styleBuiltIn = "Normal";
                  await context.sync();

                  /* Tabel */
                  if (dokumentdata[0].tabeller.hasOwnProperty(k)) {
                    var parse = require("json-templates");
                    var parseKolonner = parse(dokumentdata[0].tabeller[k].kolonner);

                    var rowsFullArray = udvalgsdata.bevillingsområde[i][substruktur][0][k];
                    var rows = rowsFullArray.map(subArray => subArray[0])
                    var rowsCount = rows.length;
                    var columns = parseKolonner({lastYear: lastYear2, nextYear: currentYear});
                    
                    var parse = require("json-templates");
                    var parseTabelBeskrivelse = parse(dokumentdata[0].tabeller[k].beskrivelse);
                    var tabelBeskrivelse = parseTabelBeskrivelse({bevillingsomraade: udvalgsdata.bevillingsområde[i].navn});

                    var includeProjects = ((k === "servicerammen" & udvalgsdata.bevillingsområde[i][substruktur][0].hasOwnProperty("projekter")) ? true : false);
                    var data = buildTableMatrix(rows,columns,includeProjects,true,withData);

                    var indsatTabel = context.document.body.insertTable(data.length, data[0].length, "End", data);
                    indsatTabel.select();
                    await context.sync();
                    formatSelectedTable();

                    insertBookmark(indsatTabel, dokumentdata[0].tabeller[k].kortnavn, i);

                    var indsatFodnote = context.document.body.insertText(dokumentdata[0].tabeller[k].note, Word.InsertLocation.end);
                    indsatFodnote.font.size = 9;
                    indsatFodnote.font.italic = true;
                    await context.sync();

                    var emptyParagraph= context.document.body.insertParagraph("", Word.InsertLocation.end);
                    emptyParagraph.styleBuiltIn = "Normal";
                    await context.sync();

                    tableAltBeskObj(udvalgsdata.bevillingsområde[i].navn + " - " + dokumentdata[0].tabeller[k].navn, tabelBeskrivelse);
                  } 

                  /* Underoverskrifter (hvis mere end en) */
                  if (rowsCount > 1) {
                    for (var rw = 0; rw <= rowsCount - 1; rw++) {
                      var underoverskrift = context.document.body.insertParagraph(rows[rw], Word.InsertLocation.end);
                      underoverskrift.styleBuiltIn = "Heading5";
                      
                      await context.sync();

                      var emptyParagraph= context.document.body.insertParagraph("", Word.InsertLocation.end);
                      emptyParagraph.styleBuiltIn = "Normal";
                      await context.sync();
                    }
                  }
                }
              }
              /* Indsætter afsnit vedr. konsenvenser for fremtiden */
              var underoverskrift = context.document.body.insertParagraph("Konsekvenser for "+currentYear+"-"+budgetperiodeÅr3+" på " + dokumentdata[0].struktur[substruktur].overskrift.toLowerCase(), Word.InsertLocation.end);
              underoverskrift.styleBuiltIn = "Heading4";
              await context.sync();
    
              var emptyParagraph= context.document.body.insertParagraph("", Word.InsertLocation.end);
              emptyParagraph.styleBuiltIn = "Normal";
              await context.sync();
            }

          }

        }        
      }
    } 
    console.log("nåede hertil");
  });
}
